import {
	Card, Flex, FormatNumber, HStack, Stack,
	Text,
	type FormatNumberProps,
} from '@chakra-ui/react';
import { DefaultStyle } from '@packages/wastic-shared';

import React from 'react';

type PromotionCardProps = {
	promotion: {
		name:         string;
		description?: string | null;
		amount:       number;
		type:         'PERCENTAGE' | 'FIXED_AMOUNT';
	};
};

const PromotionCard = ({ promotion }: PromotionCardProps) => {
	const isPercentage = promotion.type === 'PERCENTAGE';

	const formatNumberProps: Partial<FormatNumberProps> = isPercentage
		? { style: 'percent' }
		: {
			currency:        'THB',
			currencyDisplay: 'narrowSymbol',
			style:           'currency',
		};

	return (
		<Card.Root>
			<Card.Body px={4} py={2}>
				<HStack alignItems={'center'} justifyContent={'space-between'}>
					<Stack gap={DefaultStyle.NO_GAP}>
						<Card.Title textStyle={'h6'}>{promotion.name}</Card.Title>
						{promotion.description && <Card.Description>{promotion.description}</Card.Description>}
					</Stack>
					<Flex
						as={'span'}
						color={'green.600'}
						gap={1}
						textStyle={'h6'}
					>
						<FormatNumber {...formatNumberProps} value={promotion.amount} />
						<Text color={'green.600'} textStyle={'h6'}>OFF</Text>
					</Flex>
				</HStack>
			</Card.Body>
		</Card.Root>
	);
};

export default PromotionCard;